export default {
  userHint: 'The username is incorrect',
  passwordHint: 'The password is incorrect',
  err: 'Error',
  title: 'Log in',
  userName: 'Username',
  passWord: 'Password',
  hint: 'Please contact the school administrator to reset your password.',
  forgetPassword: 'Forget password？',
  login: 'Log in',
  needUserName: 'Please input username',
  needPassword: 'Please input password',
  cloudRes: 'Cloud Coursewares',
  courseIndex: 'Cloud Lessons',
  courseMy: 'My Lessons',
  ownerCourse: 'My Resource',
  courseEdit: 'New Lesson',
  classIndex: 'Start Class',
  // 新版登录页
  loginFuture: 'Log in',
  noAccount: 'No accout?',
  registerNow: 'Sign Up for FREE！',
  registerNotOpen: 'Coming soon!',
  resType: {
    image: '360 Photos',
    VR: 'VR Lessons',
    threeD: '3D Models',
    video: '360 Videos'
  },
  subject: {
    Chinese: 'Chinese',
    Math: 'Math',
    English: 'English',
    Physics: 'Physics',
    Chemistry: 'Chemistry',
    Biology: 'Biology',
    History: 'History',
    Geography: 'Geography',
    Politics: 'Politics',
    Science: 'Science',
    Safe: 'Safety Education',
  },
  loginInfo: {
    v001: 'Future Class - Global Leading',
    v002: 'XR Cloud Educational Platform',
    v10: 'Cloud Lesson Library - Building an Immersive Classroom',
    v111: `Improving Students'`,
    v112: 'Concentration and ',
    v113: 'Cognitive Effect',
    v20: 'XR Courseware Library - the Largest in the World.',
    v21: 'Coursewares，You Can Create Your Personalized XR Classroom Freely',
    v30: 'Efficient Classroom and Flexible System Management',
    v31: 'Strong and Easy Classroom Control',
    v32: 'Distributing XR Lessons with One-click',
    v33: 'Switching Seamlessly between Android, iOS and Windows Platform',
    v34: 'Smart and Flexible System Management',
    v35: `In the future classroom, you can monitor, mute, remote shutdown, lock all the students' headsets, so as to make the classroom more efficient.`,
    v36: `Massive XR coursewares and lessons can be quickly distributed to student equipment, and the transmission speed is faster under one Wi-Fi.`,
    v37: 'Web-based system, you can switch between Android, IOS and Windows flexibly, making the classroom more unbounded.',
    v38: `XR coursewares can be installed or uninstalled remotely on students' headsets, Configuring users for every headset in different classes`
  },
  // ssss
  VCourse: {
    keyword: 'Keywords',
    reslist: 'Coursewares',
    addCourse: 'Save as My Lessons',
    editCourse: 'Edit',
    back: 'Back',
    goCourse: 'Start Class',
    addCourseSuccess: 'Save successfully, you can check it in "My Lessons"'
  },

  vLangSelect: {
    title: 'VR Teaching System',
    default: 'English'
  },
  vLogin: {
    userHint: 'The username is incorrect',
    passwordHint: 'The password is incorrect',
    err: 'Error',
    title: 'VR Teaching System',
    userName: 'Username',
    passWord: 'Password',
    hint: 'Please contact the school administrator to reset your password.',
    forgetPassword: 'Forget password？',
    login: 'Log in',
    needUserName: 'Please input username',
    needPassword: 'Please input password'
  },
  vPlayList: {
    PlayList: 'Playlist'
  },
  vResItem: {
    returnIndex: 'Back to Homepage',
    myCourse: 'My Courses',
    exit: 'Sign Out',
    return: 'Back',
    selectCourseware: 'Please select the courseware you want to add.',
    added: ' has been added',
    addErr: 'Add error',
    enterCourseName: 'Please enter the course name',
    enterDateOrTime: 'Please enter the date or time',
    enterCourseOrTime: 'Please enter the course or time',
    addSuccess: 'Add successfully',
    addFail: 'Add failed',
    coursewareDetail: 'Resource details',
    stuControl: 'VR Control',
    title: 'VR Teaching System',
    module: 'Module',
    screenshot: 'Screenshot',
    coreContent: 'Core content',
    duration: 'Duration',
    control: 'VR Control',
    interaction: 'Interaction',
    joinCourse: 'Join the course',
    stuActCard: 'Student Task Card',
    notSupportTip: 'This resource only supports viewing in browsers',
    description: 'Description:',
    knowledgeSummary: 'Summary',
    useSuggest: 'Add to Courses',
    selectCourse: 'Please select the courses you want to add:',
    add: 'Add',
    newCourse: 'New course',
    cancel: 'Cancel',
    courseTitle: 'Course Title',
    enterCourse: 'Please enter the course name:',
    classTime: 'Class Time',
    confirm: 'Save',
    viewResult: 'You can view the results in \'My Courses\'',
    playOrder: 'Play in order',
    processControl: 'Process control',
    voiceExplanation: 'Voice explanation',
    stare: 'Stare',
    click: 'Click',
    movePoint: 'Move to fixed point',
    getFail: 'Acquisition failed',
    deviceStatus: 'The status of students\' VR devices:',
    remoteOff: 'Remote shutdown',
    cmdMode: 'Command mode',
    on: 'Turn on',
    off: 'Turn off',
    joinCourse2: 'Add to Courses',
    isSwitchModeHint: 'Do you sure you want to switch modes',
    switchModeHint: ['Switched to command mode', 'Switched to free mode'],
    modeSwitchFail: 'Mode switch failed',
    selectDevice: 'Select Devices',
    selectAll: 'Check All',
    offline: 'Offline',
    playing: 'Playing',
    lowPower: 'Low charge',
    playCnt: 'List of Chapters',
    pause: 'Stop',
    offHint: 'Do you want to shut down?',
    operationSuccess: 'Successful operation',
    operationFailHint: 'The operation failed, please try again',
    operationFail: 'Operation failed',
    selectDeviceHint: 'Please select the device first',
    playThis: 'Play',
    getFailHint: ['Acquisition failed', 'please try again later'],
    netWorkHint: 'The network is down, please check the network',
    appPlayerTip: '',
    noPlayItem: 'Please select the courseware to play in the list on the left',
    loading: 'Loading……',
    joinlist: 'Add to Lesson',
    back: 'Back',
    chapterlist: 'List of Chapters',
    nomore: 'No data',
    explainTitle: 'Tips:',
  },
  vResList: {
    all: 'All',
    subCharater: 'by Subject',
    natureCharater: 'by General',
    returnIndex: 'Back to Homepage',
    title: 'VR Teaching System',
    findDream: 'Input keywords to search',
    exit: 'Sign Out',
    myCourse: 'My Courses',
    sysManage: 'System Management',
    search: 'Search',
    type: 'Type',
    character: 'Character',
    classify: 'Classify',
    phaseOfStudy: 'Stage',
    secClassify: 'Secondary classification',
    subject: 'Subject',
    grade: 'Grade',
    kenowledgePoint: 'Knowledge point',
    books: 'Volume',
    resourceHint: ['A total of', 'resources'],
    getFailHint: ['Acquisition failed', ', please try again later'],
    findTotal: 'A total of ',
    findRes: ' results',
    findRes2: ' results'
  },
  vCourse: {
    all: 'All',
    myCourse: 'My Courses',
    returnIndex: 'Back to Homepage',
    addCourse: 'Add course',
    exit: 'Sign Out',
    enterCourseName: 'Please input the course name',
    enterCourseOrTime: 'Please enter the course name or time',
    changeSuccess: 'Successfully modified',
    changeFail: 'Fail to modify',
    delSuccess: 'Successfully deleted',
    delTip: 'TIP',
    delClassSuccess: 'The lesson was successfully deleted.',
    enterDateOrTime: 'Please enter the date or time',
    title: 'VR Teaching System',
    classTime: 'Class Time',
    vrCourseware: 'VR Courseware',
    video: 'Video',
    model: '3D Model',
    removeCourseware: 'Remove',
    addSuccess: 'Add successfully',
    addFail: 'Add failed',
    totalCourse: ['A total of ', ' courses'],
    changeCourse: 'Edit Course',
    courseTitle: 'Course Title:',
    confirm: 'Sure',
    cancel: 'Cancel',
    newCourse: 'New course',
    enterCourse: 'Please enter the course name',
    removeCourse: 'Delete',
    delHint: [
      'If the course',
      'is deleted, it will not be restored. Please be cautious.'
    ],
    delHints: 'Do you want to delete this course?',
    removeHint: ['The courseware', ' will be removed from the course.'],
    removeHints:
      'Once removed, the courseware can be added to the course again from the repository.',
    removeHintt: 'Continue to remove?',
    // -----新增
    inCourseware: 'Enter classroom'
  },
  vAdmin: {
    all: 'System Management',
    download: 'Download Management',
    install: 'Install Management',
    accountManage: 'Account Management',
    contentManage: 'Courseware Management',
    binding: 'Student-device Binding',
    help: 'System Help'
  },
  vAccount: {
    vAdmindownload: 'Download',
    install: 'Install Details',
    accountManage: 'Account Management',
    accountManange: 'Account Management',
    newAccount: 'New Account',
    editAccount: 'Edit',
    account: 'Username',
    nickname: 'Nickname',
    entNickname: 'Please input a nickname',
    password: 'Password',
    enterPassword: 'Please input password',
    enterHint: '6-20 characters,please use alphanumeric characters or underscores.',
    fillHint: 'If empty,it will be ignored,',
    confrimPassword: 'Confirm password',
    repeatPassword: 'Please input the password again',
    repeatFillHint: 'Please input the password again',
    repeatErrHint: 'Your confirmed password and new password do not match. ',
    operationSuccess: 'Successful operation',
    err: 'Error',
    phaseOfStudy: 'Stage',
    subject: 'Subject',
    createTime: 'Create Time',
    operation: 'Operations',
    edit: 'Edit',
    tipdel:
      'The account cannot be recovered once deleted, and all data of the account will be cleared,',
    tipdel2: ' continue or not?',
    del: 'Delete',
    cancel: 'Cancel',
    getFailHint: ['Acquisition failed', 'please try again later']
  },
  vInstall: {
    vAdmindownload: 'Download',
    install: 'Installed Details',
    accountManage: 'Account Management',
    install2: 'Details',
    installAll: 'Install All',
    operationSuccess: 'Successful operation',
    gotIt: 'Got it',
    operationFailHint: 'Operation failed, please try again…',
    resourceId: 'ID',
    resourceName: 'Title',
    resourceCover: 'Cover',
    downloadTime: 'Download time',
    installed: 'Installed',
    installing: 'Installing',
    uninstall: 'Not Installed',
    installFail: 'failed',
    operation: 'Operations',
    viewDetail: 'Details',
    installHint: [
      'Equipment installation status list (the green are installed, ',
      'the yellow are under installation, the gray are not installed, and the red are fail to install)'
    ],
    getFailHint: ['Acquisition failed', '., please try again later'],
    devices: 'Devices',

    allInstall: 'Install Management',
    alltype: 'All Types',
    allstate: 'All States',
    needupdate: 'Need to update',
    noupdate: 'No need to update',
    tipsearch: 'Input keywords to search',
    allupdate: 'Install All',
    alluninstall: 'Uninstall All',

    yesupdate: 'Confirm installation',
    tipupdate: [
      'After click \'Install\' buttom, ',
      'the courseware will be installed on the devices',
      ' which has not installed the courseware, '
    ],
    tipupdate1: 'and you can continue to install or uninstall other coursewares.',
    btnupdate: 'Continue',
    cancel: 'Cancel',
    yesuninstall: 'Unstallation Confirm',
    tipuninstall:
      'After click \'Uninstall\' buttom, the courseware will be uninstalled from the devices, ',
    tipuninstall2: 'and you can continue to install or uninstal other coursewares. ',
    plasechose: 'Please select the courseware firstly',
    confirm: 'OK',
    name: 'Title',
    type: 'Type',
    allphaseOfStudy: 'Stage',
    allsubject: 'Subject',
    phaseOfStudy: 'Stage',
    subject: 'Subject',
    grade: 'Grade',
    updateyesorno: 'Update',
    no: 'No',
    yes: 'Yes',

    btninstall: 'Install',
    btnuninstall: 'Uninstall',
    info: 'Details',
    refresh: 'Refresh',
    refreshDone: 'Refresh successfully',
    refreshFail: 'Refresh failed',
    // 1.7.2
    viewCourse: 'View by Coursewares',
    viewDevice: 'View by Devices',
    back: 'Back'
  },
  vStudy: {
    alltype: 'Classes',
    lesson: 'Title',
    start: 'Start time',
    end: 'End time',
    teacher: 'Teacher',
    class: 'Class',
    selectStudent: 'Students',
    search: 'Search',
    all: 'All',
    test: 'Students',
    operation: 'Operations',
    view: 'View more',
    tipsearch: 'Input keywords to search',
    personalAttempt: ' Comparison of the number of attempts',
    personalAttemptNum: 'Number of attempts',
    averageTimes: 'Average attempts of class',
    pointMastery: 'Mastery of knowledge points ',
    personalStatistics: 'Personal assessment at each knowledge point ',
    correct: 'Correct',
    error: 'Wrong',
    empty: 'Not submitted ',
    timeComparison: 'Comparison of duration at each knowledge point',
    personalTime: 'Duration',
    averageClassTime: 'Average duration',
    progressDesc: 'Process settings',
    examinationNotes: 'Knowledge points',
    step: 'Steps',
    description: 'Descriptions',
    includingTest: 'Included knowledge points',
    accuracyRate: 'Rate of correct',
    errorRate: 'Rate of wrong',
    emptyRate: 'Rate of not submitted',
    perNum: 'Students',
    learningRating: ' Learning Assessment ',
    ratingDistribution: 'Proportion of the levels of assessment ',
    overallCompletion: ' Completion of each step ',
    knowledgeMastering: 'Course progress and knowledge mastery',
    processSetup: 'Descriptions of process settings',
    pointTestNum: 'Number of attempts',
    maxTest: 'Maximum',
    minTest: ' Minimum',
    averageTest: 'Average',
    pointTime: 'Durations at each knowledge point',
    maxTime: 'Maximum',
    minTime: 'Minimum',
    averageTime: 'Average',
    teachData: 'Statistics',
    levelA: 'A',
    levelB: 'B',
    levelC: 'C',
    levelD: 'D',
    levelOther: 'Not submitted',
    minute: 'Min',
    completeNum: 'Completed',
    lessonSet: 'Course process',
    getData: 'More learning data is being collected.',
    getDataFinished: 'The learning data has been collected, click here to see more.',
    studyData: 'Learning data',
    pointsCount: 'Percentage statistics of each knowledge point',
    xAxisText: 'Step-Knowledge Point',
    cNum: 'Times',
  },
  vDownload: {
    vAdmindownload: 'Download',
    install: 'Install Details',
    accountManage: 'Account Management',
    toBeDownload: 'To be download',
    downloaded: 'Downloaded',
    chooseHint: 'Please select firstly',
    err: 'Error',
    name: 'Title',
    download: 'Download',
    downloadToServer: 'Download to the server',
    size: 'Size',
    downloadStartTime: 'Start time of downloading',
    status: 'Status',
    operation: 'Operations',
    retry: 'Retry',

    refreshStatus: 'Refresh the downloading status',
    getFailHint: ['Acquisition failed', ', please try again later']
  },
  vContent: {
    content: 'Courseware Management',
    alltype: 'Type',
    allstate: 'Update',
    needupdate: 'Yes',
    noupdate: 'No',
    tipsearch: 'Input keywords to search',
    tipsearch2: 'Input keywords to search',
    allupdate: 'Update All',
    yesupdate: 'Confirm Update',
    tipupdate:
      'In order to operate smoothly, please don\'t update while class is going, ',
    tipupdate1:
      'and make sure that all devices are on and connected to the same router.',
    btnupdate: 'Continue',
    save: 'save',
    cancel: 'Cancel',
    yesuninstall: 'Not Installed',
    tipuninstall:
      'After click \'Uninstall\' buttom, the courseware will be uninstalled from the devices,',
    tipuninstall2: 'and you could continue to install or uninstall other coursewares.',
    confirm: 'OK',
    name: 'Title',
    type: 'Type',
    allphaseOfStudy: 'All Types',
    allsubject: 'All Stages',
    phaseOfStudy: 'Stage',
    subject: 'Subject',
    grade: 'Grade',
    updateyesorno: 'Update',
    no: 'No',
    yes: 'Yes',
    operation: 'Operations',
    update: 'Update',
    edit: 'Edit',
    refresh: 'Refresh',
    refreshDone: 'Refresh successfully',
    refreshFail: 'Refresh failed',
    plasechose: 'Please select Stage',
    operationSuccess: 'Successful operation',
    alertTitle: ''
  },
  vBinding: {
    classlist: 'Classes',
    classname: 'Class Name',
    classnum: 'Binded Number',
    creattime: 'Create Time',
    newclass: 'New Class',
    editclass: 'Edit Class',
    bindingstudent: 'Bind',
    delcalss: 'Delete',
    devicenum: 'Device No.',
    mac: 'MAC',
    studentname: 'Student Name',
    handle: 'Operations',
    editbinding: 'Edit Binding',
    delbinding: 'Unbind',
    bindinglist: 'Batch Unbind',
    refresh: 'Refresh',
    refreshDone: 'Refresh successfully',
    refreshFail: 'Refresh failed',
    // 2019年05月20日新增
    titname: 'Student-device binding',
    edittitname: 'Student-device binding',

    tipclassname: 'Please input class name',
    tipstudentname: 'Please input student name',
    operationSuccess: 'Successful operation',
    btnsave: 'Save',
    btnyes: 'OK',
    btndel: 'Delete',
    btnunbind: 'Unbind',
    btncancel: 'Cancel',
    tipunbind1: 'Do you confirm of removing the bind between',
    tipunbind2: ' the device',
    tipunbind3: ' and student?',
    plasechose: 'Please select the device first.',
    delclasstip1:
      'After deleting class, the bond students data  will be cleared and can not be recovered,',
    delclasstip2: 'continue or not?'
  },
  play: {
    hint: 'Touch the blank space and close.'
  },
  vAccountForm: {
    edit: 'Edit',
    newAccount: 'New Account',
    save: 'Save',
    cancel: 'Cancel',
    account: 'Accounts',
    enterAccount: 'Please input username',
    accountHint: '4-30 characters,please use alphanumeric characters or underscores.',
    nickname: 'Nickname',
    enterNickname: 'Please input nickname',
    password: 'Password',
    enterPassword: 'Please input password',
    passwordHint: '6-20 characters,please use alphanumeric characters or underscores.',
    modifyHint: ['If empty,it will be ignored,', 'If modified'],
    confirmPassword: 'Confirm password',
    repeatPassword: 'Please enter the password again',
    checkPassword: 'Your confirmed password and new password do not match. ',
    operationSuccess: 'Successful operation',
    err: 'Error',
    phaseOfStudy: 'Stage',
    subject: 'Subject',
    pleasechoose: 'Please Select to choose'
  },
  uHeader: {
    homePage: 'Homepage',
    returnIndex: 'Back to Homepage',
    title: 'VR Teaching System',
    placeHolder: 'Enter keywords to search',
    search: 'Search',
    sysManage: 'System Management',
    myCourse: 'My Courses',
    addCourse: 'New Course',
    exit: 'Sign Out',
    // -----新增
    changeName: 'Change Name',
    inputName: 'Please input a new name',
    password: 'Password',
    passwordHint: '6-20 characters,please use alphanumeric characters, underscores.',
    oldPassword: 'Please input the old password',
    enterPassword: 'Please input the new password',
    changePwd: 'Change Password',
    confirmPassword: 'Confirm password',
    repeatPassword: 'Your confirmed password and new password do not match. ',
    checkPassword: 'Your confirmed password and new password do not match. ',
    operationSuccess: 'Successful operation',
    save: 'Save',
    cancel: 'Cancel',
    err: 'Error',
    CloudLibrary: 'Cloud Library',
    mylist: 'My Playlists',
    Playbackcontrol: 'Preview',
    Classview: 'Classview',
    installInfo: 'Details',
    exitclass: 'Exit',
    back: 'Back',
    siteName: 'Future Class'
  },

  vsider: {
    playlist: 'Playlist',
    save: 'Save as ...',
    sendout: 'Send Courseware',
    del: 'Clean',
    nofind: 'Can not find anything',
    noth: 'Nothing',
    addsuccess: 'Add Successfully',
    readd: 'Already added',
    siderlinulltip1: 'Please create your playlist ',
    siderlinulltip2: 'by dragging and dropping the resources to the right side.',
    saveaslist: 'Save as a playlist',
    saveaslistfail: 'Failed to save the list.',

    tipaddtolist: 'Please drag and drop the courseware to the playlist first.',
    tipsavelist: 'Please input the list name',
    tipmore: '40 characters limited',
    btnyes: 'Save',
    btncancel: 'Cancel',
    save2: 'Save',
    cancel: 'Cancel',
    createnewcourse: 'Save as a new lesson',
    savetocourse: 'Update to an existing lesson',
    choosecourse: 'Please select a lesson',
    saveplaylist: 'Save',
    clearplaylist: 'Clear',

    sendingresources: 'Send Courseware',
    sendingresourcestip1: 'The resources in the list are sent to the devices,',
    sendingresourcestip2:
      'you can check the process of sending and installing in the sector of \'Install Details\'.',
    claerlist: 'Clear the list',
    claerlisttip:
      'After clearing the list, you can still drag and drop resources into the list.',

    tipchosedevice: 'Please select the device firstly.',
    changeok: 'successfully modified',
    setok: 'Set up successfully',
    handle: 'Operations',
    name: 'Name',
    choseclass: 'Select your group',
    openoroff: 'Turn on/off control model',
    synchronouspicture: 'Synchronize the screen to the selected devices.',
    Mute: 'Turn on/off the sound',
    close: 'Remote Shutdown',

    explainPlaceholder: 'Please enter the tips here.',
    explainPlaceholder2: 'Please enter the new tips here.',
    clickToEdit: 'Cick to edit the tips',
    explainTitle: 'Tips',
    noExplain: 'No tips yet.',
    noplayALL: 'Unsaved Lesson',
    saveList: 'Save the list',
    sendRes: 'Send resources',
    clearList: 'Clear the list',
    editList: 'Edit',
    delConfirm: 'Delete',
    clear: 'Clear'
  },
  // 播控页
  playCtro: {

    saveList: 'Save the list',
    sendRes: 'Send resources',
    clearList: 'Clear the list',
    loading: 'Loading',
    empty: 'Empty',
    // 编辑清单
    editList: 'Edit',
    pleaseInputEditListName: 'Please input a new name',
    editDone: 'Edited',
    // 删除清单
    delPlayListTip: 'Do you want to delete this Playlist?',
    delPlayList: 'Delete',
    delDone: 'Deleted',
    btnyes: 'Save',
    btncancel: 'Cancel',
    saveAsList: 'Save as a list',
    saveaslist: 'Save as a playlist',
    saveaslistfail: 'Failed to save the list.',
    okText: 'Save',
    pleaseInputListName: 'Please input the list name',
    max20: '40 characters limited',
    all: 'All',
    checkAsList: 'Please select the list name',
    saveAsOldList: 'Save to an existing list',
    saveAsNewList: 'Save as a new list',

    xuekeshuxing: 'by Subject',
    ziranshuxing: 'by General',
    playListEmpty: 'Please create your playlist by dragging and dropping the resources to the right side.',
    listIsEmpty: 'The list is empty.',
    saveDone: 'Save successfully',

    // tslint:disable-next-line: max-line-length
    resSending: 'The resources in the list are sent to the devices, you can check the process of sending and installing in the sector of "Installation Details".',
    resSendDone: 'Send successfully',
    clearListTip: 'After clearing the list, you also can add resources into the list.',
    sentListTip: 'Sending is about to start. Please make sure all the target devices are on. And it\'s recommended to connect to the same WIFI for a higher speed of data transmission.',
    sendListTipConfrim: 'Send resourses',
    clearListConfirm: 'Do you want to empty the list?？',
    nomore: 'There is no online device, please make sure that the device is properly connected to the Internet and refresh the page to view.',
    reloadImg: 'Click to reload',
    installed: 'Installed',
    installing: 'Installing',
    uninstalled: 'Not Installed',
    installFailed: 'Install Failed',
    InstallationAgain: 'Reinstall',
    selectClass: 'Class',
    openControlMode: 'Control Mode: OFF',
    offControlMode: 'Control Mode: On',
    syncFrame: 'FrameSync',
    openVoice: 'Mute: On',
    mute: 'Mute: OFF',
    shutdown: 'Remote shutdown',
    pleaseSelectDevice: 'Please select device first',
    noPrevious: 'no Previous',
    noNext: 'no next',
    syncSuccess: 'Sync successfully',
    switchedToControlMode: 'Turn on control model',
    switchedToFreeMode: 'Turn off control model',
    voiceOn: 'VoiceOn',
    muted: 'Muted',
    shutdownSuccess: 'Successful shutdown',
    shutdownTips: 'Are you sure you want to shutdown all the Devices?',
    noDeviceOnline: 'No devices online.'
  },
  resource: {
    resource: 'Resource Management',
    cloudSpace: 'Clould drive:',
    baseInfo: 'Resource Uploading',
    choseResource: 'Resource file：',
    require: 'Rquired',
    noRequire: 'Recommended',
    noFile: 'None',
    loadingVideo: 'A video is uploading…',
    loadingImage: 'A 360 photo is uploading…',
    loadingModel: 'A 3D model is uploading…',
    modelUpload: 'The 3D model has been uploaded.',
    currentResource: ' Current resource ',
    dragResource: ' Please click or drag and drop the file to this area to start uploading.',
    format: 'Format supported:',
    videoType: 'Video type ',
    screenVidoe: 'Spherical panoramic video',
    normalVideo: '2D plane video ',
    videoRule: 'Required. If you cannot confirm the video type, please switch the video type according to the preview screen.',
    screenImg: '360 photos：.png，.jpg，.jpeg；',
    video: 'Videos：.mp4；（only spherical panoramic video surpported）；',
    model: '3D models：.gltf，.zip',
    cover: 'Cover：',
    uploadingCover: 'The cover is uploading…',
    currentCover: 'Current cover',
    dragCover: 'Please click or drag and drop the cover to this area to start uploading.',
    coverFormat: 'Format supported：.png，.jpg，.jpeg；',
    resolution: 'Resolution：not greater than 1920*1080；',
    resourceName: ' Resource title:',
    resourceNameRule: ' Required, up to 80 characters.',
    resourcePoint: ' Summary:',
    resourcePointRule: 'Recommended, up to 600 characters. The summary involved can be described here.',
    resourceDesc: 'Description:',
    resourceDescRule: 'Recommended, up to 600 characters. The resource can be described here.',
    resourceLable: 'Resource tags:',
    resourceLableRule: 'Recommended, up to 80 characters. If there are multiple tags, use commas to separate them.',
    subject: 'Subject：',
    subjectRule: 'Recommended, subject can be used to search by category.',
    primary: ' Primary:',
    middle: 'Secondary:',
    chinese: 'Literature',
    math: 'Math',
    english: 'Language',
    physics: 'Physics',
    chemistry: 'Chemistry',
    biology: 'Biology',
    resourceId: 'Resource ID',
    resourceType: 'Resource Type',
    updater: 'Uploaded by',
    dataSize: 'File Size',
    updateTime: 'Create Time ',
    refreshTime: 'Update Time',
    operation: 'Actions ',
    addResource: 'Upload',
    download: 'Download',
    edit: 'Edit',
    delete: 'Delete',
    deleteTip: ' The resource cannot be recovered after being deleted. Are you sure you want to delete it? ',
    btnyes: 'Delete',
    btnno: 'Cancel',
    deleteTitle: 'Delete',
    listCover: 'Cover',
    listName: 'Resource Title',
    readAndAgree: 'I have read and agree to the',
    updateRule: ' Information for Uploading Resources.',
    save: 'Save',
    cancel: 'Cancel',
    noResource: 'No resource selected, please select the resource to upload.',
    resourceUpdating: 'Please wait while the resource is being uploaded.',
    wrongData: 'Unsupported file type, please select the correct file.',
    outsizeData: 'The cloud drive has insufficient capacity to upload.',
    muchData: 'Multiple file uploads are not supported.',
    emptyName: 'The resource title is required.',
    no: 'None',
    xrUpdateRule: 'Information for Uploading Resources',
    uploadAlready: 'The file has been uploaded and there is no need to upload it again.',
    hasUploaded: 'Uploaded',
    noneUploaded: 'Not uploaded'

  },
  uploadRule: {
    ruleTitle: 'Information for Uploading Resources',
    rule: {
      rule0: '1. When using XR education cloud platform products and / or services, users should abide by laws, regulations, public order, respect social ethics, and must not endanger network security or use the network to endanger national security, honors, and interests. Incitement to subvert state power, overthrow the socialist system, incitement to split the country, undermine national unity, promote terrorism, extremism, promote national hatred, ethnic discrimination, spread violence, obscene and pornographic information, fabricate and spread false information to disrupt economic and social order , And activities that infringe on the reputation, privacy, intellectual property rights and other legal rights and interests of others. In any case, once the XR education cloud platform reasonably believes that the user has the above behavior, it can terminate the provision of products and / or services to the user at any time without prior notice.',
      rule1: '2. users are prohibited from using the products and services provided by the XR education cloud platform to engage in the following acts:',
      rule2: '2.1 Making, uploading, copying, transmitting, disseminating includes any objections to the basic principles established by the Constitution, endangering national security, divulging state secrets, subverting state power, undermining national unity, undermining national unity, undermining national honor and interests, and inciting national hatred Laws and administrative regulations prohibit ethnic discrimination, undermine national unity, undermine national religious policies, promote cults and feudal superstition, obscenity, pornography, gambling, violence, homicide, terror or abet crimes, insult or defame others, and infringe on the legal rights of others. The content or other objections include but are not limited to information, data, text, software, music, photos, graphics, information or other materials;',
      rule3: '2.2 Harm minors in any way;',
      rule4: '2.3 Pretend to be any person or organization, or falsely or falsely lie or make people think that it is related to any person or organization;',
      rule5: '2.4 Fake the title or manipulate the identification data in other ways, making people mistakenly believe that the content is transmitted by the XR education cloud platform;',
      rule6: '2.5 Upload, post, email or otherwise transmit content that is not authorized to be transmitted (such as internal information, confidential information);',
      rule7: '2.6 Upload, post, email or otherwise transmit content that infringes on anyone ’s patents, trademarks, copyrights, trade secrets or other exclusive rights;',
      rule8: '2.7 Users must ensure that their uploaded content does not contain the following;',
      rule9: '2.7.1 Opposing the basic principles determined by the Constitution;',
      rule10: '2.7.2 Endangering national unity, sovereignty and territorial integrity;',
      rule11: '2.7.3 Leaking state secrets, endangering national security, or harming national honor and interests;',
      rule12: '2.7.4 Inciting ethnic hatred, ethnic discrimination, undermining ethnic unity, or infringing on ethnic customs and habits;',
      rule13: '2.7.5 Promoting cults and superstitions;',
      rule14: '2.7.6 Disturbing social order and destroying social stability;',
      rule15: '2.7.7 Inducing minors to commit crimes and display violence, pornography, gambling, or terrorist activities;',
      rule16: '2.7.8 Insulting or defamation of others, infringement of citizens\' personal privacy and other legal rights and interests of others;',
      rule17: '2.7.9 Endangering social morality and national excellent cultural traditions;',
      rule18: '2.7.10 Other contents prohibited by relevant laws, administrative regulations and state regulations.',
      rule19: 'If the upload content provided by the user contains the above information or content that violates the policies, laws and regulations, the user directly bears all the adverse consequences caused by the above. All losses caused.',
      rule20: '3. Users who use XR education cloud platform products and / or services to make, upload, publish, and distribute symbols, text, pictures, audio, video, and other content on the XR education cloud platform should ensure that their uploaded content does not violate the use of Laws and regulations and related normative documents do not infringe on the legal rights and interests of any third party. Otherwise, all adverse consequences caused by the user will be borne by the user themselves. If the XR education cloud platform is lost, it shall also be liable for compensation. If the relevant right holder claims the right to the XR education cloud platform due to the user\'s violation of this agreement, the XR education cloud platform has the right to directly delete, log off, and block the relevant disputed content without notifying the uploading user.',
      rule21: '4. Users shall independently and completely bear legal responsibility for the use of XR education cloud platform services to produce, upload, publish, and spread symbols, text, pictures, audio, video, and other content, including those that cause losses to the XR education cloud platform. The XR Education Cloud Platform shall be liable for compensation. Simultaneously:',
      rule22: '4.1 In order to maintain the laws and regulations and related regulatory documents used by users in the XR education cloud platform service area, protect the legitimate rights and interests of others, and maintain the credibility and security of the XR education cloud platform, the XR education cloud platform has the right to directly delete users using the XR education cloud Platform products and / or services produce, upload, publish, disseminate symbols, text, pictures, audio, video and other content without prior notice to users;',
      rule23: '4.2 The background record of XR education cloud platform may be used as evidence of user\'s violation of laws, regulations, breach of contract and infringement.',
      rule24: '4.3 Users should ensure that they will not use the XR education cloud platform service or its derivative services to infringe the legal rights and interests of the XR education cloud platform and others, and prohibit the use of network vulnerabilities, malware or other illegal means to disrupt the normal operation and stealing of the XR education cloud platform 2. Misappropriation of other people\'s account and property under the account; other contents that violate the legal rights and interests of others are prohibited. Otherwise, XR Education Cloud platform has the right to freeze and block the user and user account according to the serious circumstances. If it constitutes a crime, XR Education Cloud Platform has the right to hand over to the competent department to deal with.'
    }
  },
  vStudentList: {
    stuMenage: 'Student management',
    studentCreate: 'Add',
    studentLabel: 'Please enter the student name',
    studentTips: 'Student name cannot be empty',
    stuNumTip1: 'Please enter a sequence of numbers within 20 digits.',
    stuNumTip2: 'Please enter a unique student number',
    stuNumTip3: 'Must be all numbers',
    classEdit: 'Edit',
    classStu: 'Students',
    stuNum: 'Number of students',
    editName: 'Edit name',
    stuNameTip1: 'Please enter the student\'s name',
    stuNameTip2: 'Student name cannot be empty',
    stuNumText: 'Student ID',
    uploadTip1: 'Please upload a file',
    uploadTip2: 'Select a document',
    downLoad: 'Click to download',
    downExample: 'Import',
    stuName: 'Name',
    stuNumber: 'Student ID',
    importExcel: 'Import',
    exportExcel: 'Export',
    editStudent: 'Edit',
    removeStudent: 'Remove students',
    stuIndex: 'ID',
    stuName2: 'Student name',
    example: 'Examples',
    classCreate: 'Add',
    classDelete: 'Del',
    className: 'Class name',
    removeOther: 'Move out to other classes',
    removeToClass: 'Move to class：',
    resolve: 'Success',
    messageErr: 'Information is wrong',
    stuNumberRule1: 'When entering the student ID, please ensure that the student ID is the only pure number in the school',
    status: 'Status',
    totalStudent: 'The Number of student information uploaded:',
    rightStudent: 'Effective information:',
    wrongStudent: 'Error information:',
    confirmStudentInfo: 'Confirm to upload student information',
    selectClass: 'Please select this class option',
    selectClassLabel: 'Choose the class：',
    selectClientGroup: 'Please select the device group：',
    selectLearnClass: 'Please select a class',
    fileFormatWrong: 'The file format is wrong, please upload the file in xls or xlsx format',
    tableWrong: 'No target field detected'
  },
  vClients: {
    finishNumLabel: 'Completion Test Number ',
    currentNumLabel: 'Current Test Number',
    unStartLabel: 'UnStart Test Number ',
    testStudentRate: 'Student Test Rating Distribution ',
    studentRate: 'Rating Distribution',
    studyPointTitle: 'Knowledge points Control',
    createGroup: 'Create Group',
    edit: 'Edit',
    clients: ' Device ',
    deleteGroup: 'Delete Group',
    groupName: 'Group Name',
    editGroup: 'Edit Group',
    deleteGroupTip1: ' After deleting the group, the bound devices in the group          will return to the unbound state ',
    deleteGroupTip2: 'Delete Selected asset?？',
    clientGroup: ' Device Group ',
    clientNum: ' Device Number',
    remove: 'Remove',
    bind: 'Bind',
    clientId: 'Device ID',
    clientMac: ' Device UUID',
    status: 'Status',
    rating: 'Rating',
    unrating: 'unRating',
    studentControl: 'Students Knowledge Points Control',
    learnList: ' Knowledge Points List',
    controlInfo: 'Control Info',
    person: 'person',
    finishClass: 'Finish Class',
    finishClassAndShutDown: 'Are you sure you want to end this course?',
    finishShutDown: 'End course and shut down all',
    finishShutDownTip1: 'End this course?',
    loginOutTip1: 'This may interrupt the normal operation of this student',
    loginOutTip2: 'Are you sure to log out of the student in the device?？',
    loginOutTip3: 'Sign out',
    holding: 'Processing',
    noTest: 'No test results yet',
    clientsSet: 'Device Group Management',
    notLoginStudent: 'Not logged in',
    noClassStudent: '(Students not in my class)'
  }
}
